const Detail = () => import('@pages/preDiagnosis/Detail')
const Main = () => import('@pages/preDiagnosis/Main')

export const preDiagnosis = [
  {
    path: '/preDiagnosis/main',
    name: 'PreDiagnosisMain',
    component: Main,
    meta: {}
  },
  {
    path: '/preDiagnosis/detail/:id',
    name: 'PreDiagnosisDetail',
    component: Detail,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/preDiagnosis.route.js